




































































// @ is an alias to /src
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Header from "../components/Header.vue";
import Progress from "../components/Progress.vue";
//fomateer
import ListFomatter from "../components/Type/ListFomatter";
import ProgressInfoFomatter from "../components/Type/ProgressInfoFomatter";
//utils
import Utils from "../utils/utils";
//api
import { savedo, deleteCourse, getCourse } from "../api/api";
// @ts-ignore
// import titleImg from '../assets/title2.png';
// @ts-ignore
import JSZip from "jszip";
// @ts-ignore
import FileSaver from "file-saver";
import CheckBoxType from "./CheckBox";

@Component({
  components: { Progress }
})
export default class Home extends Utils {
  //计时器
  private clear: any = null;
  //进度条信息
  public progressInfo: ProgressInfoFomatter = {
    err: "",
    progressTxt: "",
    percent: "0%",
    downloadStart: 0
  };
  //开关进度box
  public ifShowDialog: boolean = false;
  //生成的属性
  private createNum: number | string = "";
  private createName: string = "";
  private createMinute: number = 0;
  private currentChecked: number = 0;

  private homeMinHeight: number = 0;
  private selectList: CheckBoxType[] = [
    { img: "", value: true, label: "是", checked: false },
    { img: "check.png", value: false, label: "否", checked: true }
  ];
  private selectError: string = "";
  private styleList: ListFomatter[] = [
    { title: "1", img: "qrstyle2.jpg", subtitle: "带编码和提示文字" },
    { title: "2", img: "qrstyle1.jpg", subtitle: "仅显示小程序码" }
  ];
  private createQrcodeFinished: boolean = false;
  private downloadPercent: string = "0.00%";
  private downloadWorker: any = null;
  private downloadFinishedWorker: any = null;
  private canvasFinished: boolean = false;
  private canvasPercent: string = "0.00%";
  private canvasWorker: any = null;
  private downloadedZip: boolean = false;
  private requestedDeleteCourse: boolean = false;

  // private prefix: string = '';
  // private minute: number = 0;

  private err: string = "";
  private arr: any = [];
  private currentNum: number = 0;
  private list: any = [];
  private ifclick: boolean = false;
  private zipFileInfo: any = {
    content: null,
    name: ""
  };
  public created() {
    this.saveNavIndex("1");
    this.$store.commit("navChange", 1);
    // @ts-ignore
    this.homeMinHeight = this.$parent.minHeight;
  }
  public checkMinutes(item: CheckBoxType) {
    clearTimeout(this.clear);
    if (item.value) {
      this.selectError = "内测版暂不支持购买加密分钟数";
      this.clear = setTimeout(() => {
        this.selectError = "";
      }, 3000);
      return;
    }
  }
  public resetStatus() {
    this.progressInfo = new ProgressInfoFomatter();
    this.progressInfo.downloadStart = 0;
  }
  private addLog(content: string): void {
    const now = new Date();
    const hour = ("0" + now.getHours()).substr(1);
    const minute = ("0" + now.getMinutes()).substr(1);
    const times = `[${hour}:${minute}] `;
    const element = document.getElementById("log");
    if (element) {
      element.append("\n" + times + content);
    }
  }

  private produce() {
    this.arr = [];
    this.createName = Date.now() + "";
    this.createSrc(this.createName, +this.createNum, this.createMinute);
  }

  private createSrc(name: string, num: number, minutes: number) {
    this.reset();
    this.err = "";
    name = name.trim();
    if (name.length === 0) {
      this.err = "请输入二维码名称";
      this.addLog("错误：" + this.err);
      return;
    }
    // @ts-ignore
    if (num <= 0 || isNaN(num) || num > 100) {
      this.err = "请输入正确的二维码数量（0-100正整数）";
      this.addLog("错误：" + this.err);
      return;
    }
    // @ts-ignore
    if (minutes < 0) {
      this.err = "请输入二维码分钟数（正整数）";
      this.addLog("错误：" + this.err);
      return;
    }
    this.ifShowDialog = true;
    this.addLog("开始创建二维码...");
    this.progressInfo.progressTxt = "开始创建二维码...";
    this.ifclick = true;
    this.canvasPercent = "0.00%";
    savedo({ name, num, minutes }).then((res: any) => {
      const taskId = res.data;
      if (taskId === null) {
        this.err = res.message;
        this.addLog("错误：" + res.message);
        this.progressInfo.err = "错误：" + res.message;
        this.ifclick = false;
        return;
      } else if (!res.status) {
        this.addLog("错误：" + res.message);
        this.progressInfo.err = "错误：" + res.message;
        return;
      }
      this.loadTaskStatus(taskId, num);
    });
  }

  private loadTaskStatus(taskId: any, num: number): void {
    this.downloadWorker = setInterval(() => {
      getCourse(taskId).then(res => {
        this.getCourseHandler(res, num);
      });
    }, 1000);
    this.downloadFinishedWorker = setInterval(() => {
      if (!this.createQrcodeFinished || this.requestedDeleteCourse) {
        return;
      }
      this.requestedDeleteCourse = true;
      clearInterval(this.downloadWorker);
      this.downloadWorker = null;
      deleteCourse(taskId).then(res => {
        this.deleteCourseHandler(res);
      });
    }, 100);
  }

  private getCourseHandler(res: any, num: number) {
    if (!res.status) {
      this.reset();
      this.err = res.message;
      this.addLog("错误：" + this.err);
      this.progressInfo.err = "错误：" + res.message;
      return;
    }

    this.currentNum = res.data;
    // clearTimeout(this.downloadWorker)
    // this.downloadWorker = null
    this.createQrcodeFinished = this.currentNum === num;
    this.downloadPercent = this.toPercent(this.currentNum / num);
    this.addLog("创建进度：" + this.downloadPercent);
    this.progressInfo.progressTxt = "创建进度：" + this.downloadPercent;
    this.progressInfo.percent = this.downloadPercent;
  }

  private toPercent(point: number) {
    var str = Number(point * 100);
    if (isNaN(str)) {
      str = 0;
    }
    return str.toFixed(2) + "%";
  }

  private deleteCourseHandler(res: any) {
    if (!res.status) {
      this.err = res.message;
      this.addLog("错误：" + res.message);
      this.progressInfo.err = "错误：" + res.message;
      return;
    } else if (res.data === null) {
      this.addLog("错误：" + "创建二维码没有返回数据");
      this.progressInfo.err = "错误：" + "创建二维码没有返回数据";
      return;
    }
    clearInterval(this.downloadFinishedWorker);
    // setTimeout(() => {
    //   this.progressInfo.downloadStart = 2;
    // }, 30000);
    let countNum = 0;
    setInterval(() => {
      countNum++;
    }, 1000);
    this.downloadFinishedWorker = null;
    this.list = res.data;
    this.addLog("canvas开始绘图...");
    this.progressInfo.progressTxt = "canvas开始绘图...";
    for (let i = 0; i < this.list.length; i++) {
      const item = this.list[i];
      this.addLog("编号【" + (i + 1) + "】绘图开始...");
      this.progressInfo.progressTxt = "编号【" + (i + 1) + "】绘图开始...";
      this.draw(`编号${item.name}`, "data:image/jpeg;base64," + item.url, i);
      this.addLog("编号【" + (i + 1) + "】绘图完成");
      this.progressInfo.progressTxt = "编号【" + (i + 1) + "】绘图完成";
      if (countNum == 3) {
        //30秒了
        this.progressInfo.downloadStart = 2;
        return;
      }
    }
    this.ifclick = false;
    this.canvasWorker = setInterval(() => {
      this.toDownloadZip();
    }, 1000);
  }
  private async draw(imgName: string, imgSrc: string, index: number) {
    const canvasElement = document.createElement("canvas") as HTMLCanvasElement;
    if (this.currentChecked == 0) {
      canvasElement.height = 462;
    } else {
      canvasElement.height = 396;
    }
    canvasElement.width = 396;
    canvasElement.style.height = "0";
    canvasElement.style.width = "0";
    document.body.appendChild(canvasElement);
    const content = canvasElement.getContext("2d");
    //背景图
    const locations: { [key: number]: any } = {
      0: { x: 0, y: 0, w: 396, h: 462, color: "#fff" },
      1: { x: 0, y: 0, w: 396, h: 396, color: "#fff" }
    };
    const qrSize = {
      width: 339,
      height: 339
    };
    let m: any = [];
    //初始化m循环20组二维码图片
    m[1] = this.createImg(imgSrc);
    //布置好大背景色
    this.fillRoundRect(
      content,
      locations[this.currentChecked].x,
      locations[this.currentChecked].y,
      locations[this.currentChecked].w,
      locations[this.currentChecked].h,
      0,
      locations[this.currentChecked].color
    );

    m[1].onload = () => {
      // @ts-ignore
      // content.drawImage(m[0], 0, 0, 2480, 296);
      //异步左边四个qrcode
      //字体
      if (this.currentChecked == 0) {
        // @ts-ignore
        content.drawImage(
          m[1],
          (locations[this.currentChecked].w - qrSize.width) / 2,
          21,
          qrSize.width,
          qrSize.height
        );

        //     ctx.fillText(
        //   str,
        //   (375 - ctx.measureText(str).width - (n + numNum) * letterSpace) * 0.5,
        //   top + size
        // );
        this.creatFont(content, "18px 黑体", "000000", imgName, 90, 378);
        this.creatFont(
          content,
          "37px bold 黑体",
          "000000",
          "微信扫码联系主人",
          50,
          426
        );
        // return;
      } else {
        // @ts-ignore
        content.drawImage(
          m[1],
          (locations[this.currentChecked].w - qrSize.width) / 2,
          (locations[this.currentChecked].h - qrSize.height) / 2,
          qrSize.width,
          qrSize.height
        );
      }
      setTimeout(() => {
        const url1 = canvasElement.toDataURL("image/png");
        this.arr.push({ name: imgName, url: url1, index: index });
        // @ts-ignore
        canvasElement.parentNode.removeChild(canvasElement);
      }, 0);
    };
  }
  private createImg(url: any) {
    var img;
    img = new Image();
    img.src = url;
    return img;
  }
  private drawRoundRectPath(
    cxt: any,
    width: number,
    height: number,
    radius: number
  ) {
    cxt.beginPath(0);
    //从右下角顺时针绘制，弧度从0到1/2PI
    cxt.arc(width - radius, height - radius, radius, 0, Math.PI / 2);
    //矩形下边线
    cxt.lineTo(radius, height);
    //左下角圆弧，弧度从1/2PI到PI
    cxt.arc(radius, height - radius, radius, Math.PI / 2, Math.PI);
    //矩形左边线
    cxt.lineTo(0, radius);
    //左上角圆弧，弧度从PI到3/2PI
    cxt.arc(radius, radius, radius, Math.PI, (Math.PI * 3) / 2);
    //上边线
    cxt.lineTo(width - radius, 0);
    //右上角圆弧
    cxt.arc(width - radius, radius, radius, (Math.PI * 3) / 2, Math.PI * 2);
    //右边线
    cxt.lineTo(width, height - radius);
    cxt.closePath();
  }
  private fillRoundRect(
    cxt: any,
    x: number,
    y: number,
    width: number,
    height: number,
    radius: number,
    /*optional*/ fillColor: string
  ) {
    //圆的直径必然要小于矩形的宽高
    if (2 * radius > width || 2 * radius > height) {
      return false;
    }
    cxt.save();
    cxt.translate(x, y);
    //绘制圆角矩形的各个边
    this.drawRoundRectPath(cxt, width, height, radius);
    cxt.fillStyle = fillColor || "#000"; //若是给定了值就用给定的值否则给予默认值
    cxt.fill();
    cxt.restore();
  }

  private loadingImg(
    ctx: any,
    img: string,
    x: number,
    y: number,
    w: number,
    h: number
  ) {
    return new Promise((resolve, reject) => {
      // @ts-ignore
      img.onload = function() {
        resolve(ctx.drawImage(img, x, y, w, h));
      };
    });
  }
  private creatFont(
    ctx: any,
    style: string,
    color: string,
    content: string,
    x: number,
    y: number
  ) {
    ctx.font = style;
    ctx.fillStyle = color;
    ctx.textBaseline = "middle";
    const width = ctx.measureText(content).width;
    const left = (396 - width) / 2;
    ctx.fillText(content, left, y);
  }
  private downloadZip(arr: any[], zipFileName: string, num: number) {
    this.canvasFinished = arr.length === num;
    this.canvasPercent = this.toPercent(arr.length / num);
    if (!this.canvasFinished || this.downloadedZip) {
      return;
    }
    this.downloadedZip = true;
    if (this.canvasWorker) {
      clearInterval(this.canvasWorker);
      this.canvasWorker = null;
    }
    this.addLog("构造压缩文件...");
    this.progressInfo.progressTxt = "构造压缩文件...";
    const zip = new JSZip();
    const imgs: any = zip.folder(zipFileName);
    arr.forEach(item => {
      imgs.file(item.name + ".png", item.url.substring(22), {
        base64: true
      });
    });
    this.addLog("开始下载，请稍后...");
    this.progressInfo.downloadStart = 1;
    zip.generateAsync({ type: "blob" }).then((content: any) => {
      this.zipFileInfo.content = content;
      this.zipFileInfo.name = zipFileName + ".zip";
      this.redownload();
    });
  }
  private redownload() {
    FileSaver.saveAs(this.zipFileInfo.content, this.zipFileInfo.name);
  }
  private toDownloadZip() {
    const now = new Date();
    const year = now.getFullYear();
    const month = ("0" + (now.getMonth() + 1)).substr(1);
    const day = ("0" + now.getDay()).substr(1);
    const hour = ("0" + now.getHours()).substr(1);
    const minute = ("0" + now.getMinutes()).substr(1);
    // const fileName = this.prefix + '-' + year + month + day + hour + minute;
    const fileName = year + month + day + hour + minute;
    this.downloadZip(this.arr, fileName, +this.createNum);
  }
  private reset() {
    if (this.downloadWorker) {
      clearInterval(this.downloadWorker);
      this.downloadWorker = null;
    }
    this.requestedDeleteCourse = false;
    this.downloadPercent = "0.0%";
    this.canvasPercent = "0.0%";
    this.downloadedZip = false;
    this.ifclick = false;
    this.createQrcodeFinished = false;
    this.canvasFinished = false;
  }

  private checkStyle(index: number) {
    this.currentChecked = index;
  }
}
